'use client'

import { type FC, useEffect, useMemo } from 'react'

import {
  adServerSlotsPushSyncInterestCommand,
  adServerSyncInterestCommandIsPushed,
} from '../../../ad-server'
import {
  FEATURE_TOGGLE_AD_SERVER,
  useFeatureToggle,
} from '../../../feature-toggles'
import { productAccessorGetSecondLevelCategories } from '../../model/productAccessor/productAccessorGetSecondLevelCategories'
import { useProductPageContext } from '../productPageContext'

const useAdServerGetCategoriesForProductPage = (): {
  categories: string[]
} => {
  const { product } = useProductPageContext()

  const categories: string[] = useMemo(() => {
    const secondLevelCategories = productAccessorGetSecondLevelCategories({
      product,
    })

    const { category } = product

    return category?.code
      ? [category.code, ...secondLevelCategories]
      : secondLevelCategories
  }, [product])

  return { categories }
}

/**
 * pushes data for product page to ad server slots
 *
 * @remark implemented as component and not hook, due to this needs to access the context, and we can just put it
 * where we need it.
 */
export const ProductPageAdServerPushCommand: FC = () => {
  const isAdServerEnabled = useFeatureToggle(FEATURE_TOGGLE_AD_SERVER)
  const { categories } = useAdServerGetCategoriesForProductPage()

  useEffect(() => {
    if (isAdServerEnabled && !adServerSyncInterestCommandIsPushed()) {
      adServerSlotsPushSyncInterestCommand(categories)
    }
  }, [isAdServerEnabled, categories])

  return null
}
